(function () {
  var FUZZY_THRESHOLD = 0.28;
  var FUZZY_MIN_CHARS = 2;
  var SCHOOL_TITLE_FALLBACK_RE = /\b(school|academy|college|primary|secondary|prep|grammar)\b/i;

  function debounce(callback, delay) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, delay);
    };
  }

  function escapeHtml(text) {
    var map = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    };
    return String(text).replace(/[&<>"']/g, function (match) {
      return map[match];
    });
  }

  function normalizeText(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizePostcode(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function isPostcodeLikeQuery(value) {
    var normalized = normalizePostcode(value);
    if (normalized.length < 4) return false;
    return /[a-z]/.test(normalized) && /\d/.test(normalized);
  }

  function fuzzyScore(query, target) {
    var q = normalizeText(query);
    var t = normalizeText(target);
    if (!q || !t) return 0;

    if (t.indexOf(q) !== -1) return 1;

    var qWords = q.split(/\s+/);
    var allWordsMatch = qWords.every(function (word) {
      return t.indexOf(word) !== -1;
    });
    if (allWordsMatch) return 0.85;

    function trigrams(value) {
      var set = {};
      var padded = "  " + value + "  ";
      for (var i = 0; i < padded.length - 2; i += 1) {
        set[padded.slice(i, i + 3)] = true;
      }
      return set;
    }

    var qt = trigrams(q);
    var tt = trigrams(t);
    var shared = 0;
    var totalQ = Object.keys(qt).length;
    var totalT = Object.keys(tt).length;

    Object.keys(qt).forEach(function (tri) {
      if (tt[tri]) shared += 1;
    });

    var dice = (2 * shared) / (totalQ + totalT) || 0;

    var prefixBonus = t.split(/\s+/).some(function (word) {
      return word.indexOf(q.split(/\s+/)[0]) === 0;
    })
      ? 0.15
      : 0;

    var qIndex = 0;
    var tIndex = 0;
    while (qIndex < q.length && tIndex < t.length) {
      if (q.charAt(qIndex) === t.charAt(tIndex)) qIndex += 1;
      tIndex += 1;
    }

    var subsequenceRatio = q.length ? qIndex / q.length : 0;
    var subsequenceScore = subsequenceRatio >= 0.72 ? subsequenceRatio * 0.78 : 0;

    return Math.min(1, Math.max(dice + prefixBonus, subsequenceScore));
  }

  function buildSearchText(item) {
    return [
      item.title,
      item.handle,
      item.postcode,
      item.town,
      item.address_1,
      item.address_2,
      item.address_3,
    ]
      .filter(Boolean)
      .join(" ");
  }

  function scoreCollection(query, item) {
    if (!query || !item) return 0;

    var isPostcodeQuery = isPostcodeLikeQuery(query);
    var titleScore = fuzzyScore(query, item.title || "");
    var handleScore = fuzzyScore(query, (item.handle || "").replace(/[-_]+/g, " "));
    var townScore = fuzzyScore(query, item.town || "");
    var searchTextScore = fuzzyScore(query, item.searchText || "");
    var queryPostcode = normalizePostcode(query);
    var itemPostcode = normalizePostcode(item.postcode);
    var itemHandle = normalizePostcode(item.handle);
    var postcodeScore = 0;

    if (queryPostcode && itemPostcode) {
      if (itemPostcode === queryPostcode) {
        postcodeScore = 1.45;
      } else if (itemPostcode.indexOf(queryPostcode) === 0) {
        postcodeScore = 1.25;
      } else if (itemPostcode.indexOf(queryPostcode) !== -1) {
        postcodeScore = 1.1;
      } else if (
        queryPostcode.length >= 4 &&
        queryPostcode.indexOf(itemPostcode) === 0
      ) {
        postcodeScore = 0.9;
      }
    }

    if (!postcodeScore && queryPostcode && itemHandle) {
      if (itemHandle.indexOf(queryPostcode) !== -1) {
        postcodeScore = 1;
      }
    }

    if (isPostcodeQuery) {
      return Math.max(postcodeScore, handleScore * 0.35);
    }

    if (titleScore >= 0.85 && postcodeScore >= 1.1) {
      return postcodeScore + 0.1;
    }

    return Math.max(postcodeScore, titleScore, handleScore * 0.95, townScore * 0.9, searchTextScore * 0.82);
  }

  function fuzzyFilter(query, results) {
    if (!query || query.length < FUZZY_MIN_CHARS) return results;
    return results
      .map(function (item) {
        return { item: item, score: scoreCollection(query, item) };
      })
      .filter(function (entry) {
        return entry.score >= FUZZY_THRESHOLD;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .map(function (entry) {
        return entry.item;
      });
  }

  function highlightMatch(title, query) {
    var escaped = escapeHtml(title);
    if (!query) return escaped;

    try {
      var escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      var re = new RegExp("(" + escapedQuery + ")", "gi");
      return escaped.replace(re, "<mark>$1</mark>");
    } catch (error) {
      return escaped;
    }
  }

  function normalizeCollectionUrl(shopRoot, item) {
    if (item.url) return item.url;
    if (item.handle) return shopRoot + "collections/" + item.handle;
    return "";
  }

  function normalizeCollectionItem(shopRoot, item) {
    var normalized = {
      title: item.title || "",
      url: normalizeCollectionUrl(shopRoot, item),
      handle: item.handle || "",
      image: typeof item.image === "string" && item.image ? item.image : "",
      templateSuffix:
        typeof item.template_suffix === "string"
          ? item.template_suffix
          : typeof item.templateSuffix === "string"
            ? item.templateSuffix
            : "",
      postcode:
        typeof item.postcode === "string"
          ? item.postcode
          : "",
      town:
        typeof item.town === "string"
          ? item.town
          : "",
      address_1:
        typeof item.address_1 === "string"
          ? item.address_1
          : "",
      address_2:
        typeof item.address_2 === "string"
          ? item.address_2
          : "",
      address_3:
        typeof item.address_3 === "string"
          ? item.address_3
          : "",
    };

    normalized.searchText = buildSearchText(normalized);

    return normalized;
  }

  function getShopRoot() {
    var rawRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    return rawRoot.endsWith("/") ? rawRoot : rawRoot + "/";
  }

  function getSearchState() {
    if (initSchoolSearch._state) return initSchoolSearch._state;
    initSchoolSearch._state = {
      loaded: false,
      loading: false,
      sourceMode: "loading",
      allItems: [],
      candidateItems: [],
      promise: null,
    };
    return initSchoolSearch._state;
  }

  function dedupeCollections(items) {
    var seen = {};
    var deduped = [];

    items.forEach(function (item) {
      var key = ((item.url || "") + "::" + (item.title || "")).toLowerCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      deduped.push(item);
    });

    return deduped;
  }

  function chooseCandidates(allCollections) {
    var suffixMatches = allCollections.filter(function (item) {
      return (item.templateSuffix || "").toLowerCase() === "school";
    });

    if (suffixMatches.length) {
      return {
        mode: "template_suffix",
        items: suffixMatches,
      };
    }

    var lexicalMatches = allCollections.filter(function (item) {
      return SCHOOL_TITLE_FALLBACK_RE.test(item.title || "");
    });

    if (lexicalMatches.length) {
      return {
        mode: "title_fallback",
        items: lexicalMatches,
      };
    }

    return {
      mode: "all_collections_fallback",
      items: allCollections,
    };
  }

  function getSchoolInitials(title) {
    var stopWords = /^(the|and|&|of|for|a|an|school|primary|junior|infant|academy|college|high|community)$/i;
    var words = String(title || "")
      .trim()
      .split(/\s+/)
      .filter(function (word) {
        return word && !stopWords.test(word);
      });

    if (!words.length) {
      words = String(title || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    }

    return (
      words
        .slice(0, 2)
        .map(function (word) {
          return word.charAt(0);
        })
        .join("")
        .toUpperCase() || "?"
    );
  }

  function buildSuggestionMediaHtml(item) {
    if (item.image) {
      return (
        '<span class="st-home-suggestions__media">' +
        '<img src="' +
        escapeHtml(item.image) +
        '" alt="" class="st-home-suggestions__logo" loading="lazy" width="40" height="40">' +
        "</span>"
      );
    }

    return (
      '<span class="st-home-suggestions__media st-home-suggestions__media--placeholder" aria-hidden="true">' +
      '<span class="st-home-suggestions__initials">' +
      escapeHtml(getSchoolInitials(item.title)) +
      "</span>" +
      "</span>"
    );
  }

  function buildSuggestionMeta(item) {
    var parts = [];

    if (item.town) parts.push(item.town);
    if (item.postcode) parts.push(item.postcode);
    if (!parts.length) parts.push("School collection");

    return parts.join(" · ");
  }

  function getReferSchoolUrl() {
    return getShopRoot() + "pages/refer-a-school";
  }

  function buildReferSuggestionHtml() {
    return (
      '<li role="none">' +
      '<a href="' +
      escapeHtml(getReferSchoolUrl()) +
      '" class="st-home-suggestions__item st-home-suggestions__item--refer" role="option" aria-selected="false" data-st-suggestion-refer>' +
      '<span class="st-home-suggestions__title">Can\u2019t find your school?</span>' +
      '<span class="st-home-suggestions__meta">Get in touch with us</span>' +
      "</a>" +
      "</li>"
    );
  }

  function parseEmbeddedSchoolIndexNode(node, shopRoot) {
    var parsedItems = [];
    var payload = node && node.textContent ? node.textContent : "";
    if (!payload.trim()) {
      return {
        items: [],
        totalPages: 1,
        sectionId: "",
        path: "",
      };
    }

    try {
      var list = JSON.parse(payload);
      if (Array.isArray(list)) {
        list.forEach(function (item) {
          parsedItems.push(normalizeCollectionItem(shopRoot, item || {}));
        });
      }
    } catch (error) {
      parsedItems = [];
    }

    return {
      items: parsedItems,
      totalPages: Math.max(1, Number(node.getAttribute("data-st-school-index-pages") || "1")),
      sectionId: node.getAttribute("data-st-school-section-id") || "",
      path: node.getAttribute("data-st-school-index-path") || window.location.pathname || "/",
    };
  }

  async function fetchSchoolIndexPage(path, sectionId, pageNumber, shopRoot) {
    if (!sectionId || pageNumber < 2) return [];

    try {
      var url = new URL(path || "/", window.location.origin);
      url.searchParams.set("sections", sectionId);
      url.searchParams.set("page", String(pageNumber));

      var response = await fetch(url.toString(), { credentials: "same-origin" });
      if (!response.ok) return [];

      var payload = await response.json();
      var html = payload && payload[sectionId] ? payload[sectionId] : "";
      if (!html) return [];

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var node = doc.querySelector("[data-st-school-index]");
      if (!node) return [];

      return parseEmbeddedSchoolIndexNode(node, shopRoot).items;
    } catch (error) {
      return [];
    }
  }

  async function getEmbeddedSchoolIndex() {
    var shopRoot = getShopRoot();
    var nodes = document.querySelectorAll("[data-st-school-index]");
    var parsedItems = [];

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!node) continue;

      var nodeData = parseEmbeddedSchoolIndexNode(node, shopRoot);
      parsedItems = parsedItems.concat(nodeData.items);

      if (nodeData.totalPages > 1) {
        var pagePromises = [];
        for (var page = 2; page <= nodeData.totalPages; page += 1) {
          pagePromises.push(fetchSchoolIndexPage(nodeData.path, nodeData.sectionId, page, shopRoot));
        }

        if (pagePromises.length) {
          var pageResults = await Promise.all(pagePromises);
          pageResults.forEach(function (extraItems) {
            parsedItems = parsedItems.concat(extraItems || []);
          });
        }
      }
    }

    parsedItems = parsedItems.filter(function (item) {
      return item.title && item.url;
    });
    parsedItems = dedupeCollections(parsedItems);
    parsedItems.sort(function (a, b) {
      return a.title.localeCompare(b.title);
    });

    return parsedItems;
  }

  async function loadCollectionIndex() {
    var state = getSearchState();
    if (state.loaded) return state;
    if (state.promise) return state.promise;

    state.loading = true;

    state.promise = (async function () {
      var embeddedCollections = await getEmbeddedSchoolIndex();

      try {
        var selection = chooseCandidates(embeddedCollections);

        state.loaded = true;
        state.loading = false;
        state.allItems = embeddedCollections;
        state.candidateItems = selection.items;
        state.sourceMode =
          embeddedCollections.length > 0
            ? selection.mode
            : "embedded_school_index_empty";
      } catch (error) {
        state.loaded = true;
        state.loading = false;
        state.allItems = [];
        state.candidateItems = [];
        state.sourceMode = "error";
      } finally {
        state.promise = null;
      }

      return state;
    })();

    return state.promise;
  }

  function buildSuggestions(query, state, limit) {
    var primary = fuzzyFilter(query, state.candidateItems).slice(0, limit);
    if (primary.length || state.sourceMode === "template_suffix") {
      return primary;
    }

    var fallback = fuzzyFilter(query, state.allItems).slice(0, limit);
    return fallback;
  }

  function initSchoolSearch() {
    var searchRoots = document.querySelectorAll(
      "[data-st-home-search], [data-st-school-search-root]"
    );
    if (!searchRoots.length) return;

    searchRoots.forEach(function (root) {
      if (root.dataset.stHomeSearchReady === "true") return;
      root.dataset.stHomeSearchReady = "true";

      var form = root.querySelector("form");
      var input = root.querySelector("[data-st-school-input]");
      var suggestionsNode = root.querySelector("[data-st-school-suggestions]");
      var statusNode = root.querySelector("[data-st-school-status]");
      var maxResults = Number(root.getAttribute("data-search-limit") || "8");

      if (!form || !input || !suggestionsNode) return;

      var items = [];
      var activeIndex = -1;
      var lastQuery = "";
      var referItemPresent = false;

      loadCollectionIndex().catch(function () {
        return null;
      });

      function setStatus(message) {
        if (!statusNode) return;
        statusNode.textContent = message || "";
      }

      function closeSuggestions() {
        suggestionsNode.hidden = true;
        suggestionsNode.innerHTML = "";
        input.setAttribute("aria-expanded", "false");
        activeIndex = -1;
        items = [];
        referItemPresent = false;
      }

      function getSchoolSuggestionIndex(domIndex) {
        return referItemPresent ? domIndex - 1 : domIndex;
      }

      function isReferSuggestionIndex(domIndex) {
        return referItemPresent && domIndex === 0;
      }

      function submitFormFallback() {
        if (typeof HTMLFormElement !== "undefined" && HTMLFormElement.prototype && HTMLFormElement.prototype.submit) {
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        form.submit();
      }

      function setActive(nextIndex) {
        var optionNodes = suggestionsNode.querySelectorAll(".st-home-suggestions__item");
        if (!optionNodes.length) return;

        if (nextIndex < 0) nextIndex = optionNodes.length - 1;
        if (nextIndex >= optionNodes.length) nextIndex = 0;

        activeIndex = nextIndex;

        optionNodes.forEach(function (node, idx) {
          var isActive = idx === activeIndex;
          node.classList.toggle("is-active", isActive);
          node.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      }

      function chooseSuggestion(domIndex, navigateToCollection) {
        if (isReferSuggestionIndex(domIndex)) {
          closeSuggestions();
          if (navigateToCollection) {
            window.location.assign(getReferSchoolUrl());
          }
          return;
        }

        var selected = items[getSchoolSuggestionIndex(domIndex)];
        if (!selected) return;
        input.value = selected.title;
        closeSuggestions();

        if (navigateToCollection && selected.url) {
          window.location.assign(selected.url);
          return;
        }

        if (navigateToCollection) {
          submitFormFallback();
        }
      }

      function renderSuggestions(query, results) {
        items = results || [];
        activeIndex = -1;
        referItemPresent = true;

        var schoolItemsHtml = items
          .map(function (item, index) {
            return (
              '<li role="none">' +
              '<button type="button" class="st-home-suggestions__item st-home-suggestions__item--school" role="option" aria-selected="false" data-st-suggestion-index="' +
              index +
              '">' +
              buildSuggestionMediaHtml(item) +
              '<span class="st-home-suggestions__text">' +
              '<span class="st-home-suggestions__title">' +
              highlightMatch(item.title, query) +
              "</span>" +
              '<span class="st-home-suggestions__meta">' +
              escapeHtml(buildSuggestionMeta(item)) +
              "</span>" +
              "</span>" +
              "</button>" +
              "</li>"
            );
          })
          .join("");

        suggestionsNode.innerHTML = buildReferSuggestionHtml() + schoolItemsHtml;
        suggestionsNode.hidden = false;
        input.setAttribute("aria-expanded", "true");

        if (!items.length) {
          setStatus("No matching schools found.");
          return;
        }

        setStatus(items.length + " suggestions available.");
      }

      var debouncedSearch = debounce(function () {
        var query = input.value.trim();
        if (query.length < FUZZY_MIN_CHARS) {
          closeSuggestions();
          setStatus("");
          return;
        }

        lastQuery = query;
        setStatus("Loading schools...");

        loadCollectionIndex()
          .then(function (state) {
            if (lastQuery !== query) return;

            var suggestions = buildSuggestions(query, state, maxResults);
            renderSuggestions(query, suggestions);
          })
          .catch(function () {
            if (lastQuery !== query) return;
            closeSuggestions();
            setStatus("Could not load school suggestions.");
          });
      }, 180);

      input.addEventListener("focus", function () {
        loadCollectionIndex();
        if (input.value.trim().length >= FUZZY_MIN_CHARS) {
          debouncedSearch();
        }
      });

      input.addEventListener("input", debouncedSearch);

      input.addEventListener("keydown", function (event) {
        if (suggestionsNode.hidden || (!items.length && !referItemPresent)) return;

        if (event.key === "ArrowDown") {
          event.preventDefault();
          setActive(activeIndex + 1);
          return;
        }

        if (event.key === "ArrowUp") {
          event.preventDefault();
          setActive(activeIndex - 1);
          return;
        }

        if (event.key === "Escape") {
          closeSuggestions();
          setStatus("");
          return;
        }

        if (event.key === "Enter" && activeIndex >= 0) {
          event.preventDefault();
          chooseSuggestion(activeIndex, true);
        }
      });

      suggestionsNode.addEventListener("mousedown", function (event) {
        if (event.target.closest("[data-st-suggestion-refer]")) return;

        var target = event.target.closest("[data-st-suggestion-index]");
        if (!target) return;

        event.preventDefault();
        var schoolIndex = Number(target.getAttribute("data-st-suggestion-index"));
        chooseSuggestion(referItemPresent ? schoolIndex + 1 : schoolIndex, true);
      });

      document.addEventListener("click", function (event) {
        if (!root.contains(event.target)) {
          closeSuggestions();
          setStatus("");
        }
      });

      form.addEventListener("submit", function (event) {
        var query = input.value.trim();
        if (!query.length) return;

        // If user actively picked a suggestion, route directly to its collection.
        if (activeIndex >= 0) {
          event.preventDefault();
          chooseSuggestion(activeIndex, true);
          return;
        }

        // If suggestions are visible, use the first best match by default.
        if (items.length && items[0].url) {
          event.preventDefault();
          chooseSuggestion(referItemPresent ? 1 : 0, true);
          return;
        }

        // Resolve a best-match from the full index before falling back to form query submit.
        event.preventDefault();
        closeSuggestions();
        setStatus("Finding closest school...");

        loadCollectionIndex()
          .then(function (state) {
            var matches = buildSuggestions(query, state, Math.max(maxResults, 8));
            if (matches.length && matches[0].url) {
              window.location.assign(matches[0].url);
              return;
            }

            setStatus("No direct school match found. Showing search results.");
            submitFormFallback();
          })
          .catch(function () {
            setStatus("Search index unavailable. Showing search results.");
            submitFormFallback();
          });
      });
    });
  }

  function init() {
    initSchoolSearch();
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
